/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b5060405161010f38038061010f833981016040819052602c91608a565b6040516315a722b960e31b8152600481018290526001600160a01b0383169063ad3915c890602401600060405180830381600087803b158015606d57600080fd5b505af11580156080573d6000803e3d6000fd5b50505050505060c2565b60008060408385031215609c57600080fd5b82516001600160a01b038116811460b257600080fd5b6020939093015192949293505050565b603f806100d06000396000f3fe6080604052600080fdfea2646970667358221220e5426e2a86655af539f6f74bbfe645679f19c7646c27f3e74259b7d600737fde64736f6c63430008170033";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperAppMockUsingRegisterApp__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, configWord, overrides) {
        return super.deploy(host, configWord, overrides || {});
    }
    getDeployTransaction(host, configWord, overrides) {
        return super.getDeployTransaction(host, configWord, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperAppMockUsingRegisterApp__factory.bytecode = _bytecode;
SuperAppMockUsingRegisterApp__factory.abi = _abi;
//# sourceMappingURL=SuperAppMockUsingRegisterApp__factory.js.map